export const NAVBAR_HEIGHT = 80;
